import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Navbar from 'react-bootstrap/lib/Navbar';

import Navigation from '../Navigation';
import Logo from '../Logo';
import Toaster from '../Toaster';
import DropDownMenu from '../DropDownMenu/DropDownMenu';
import LoadingBar from 'react-redux-loading-bar';

import history from '../../core/history';
import { toggleOpen, toggleClose } from '../../actions/Menu/toggleControl';

import s from './Header.css';

const HomeHeader = ({ borderLess, searchDisablePages }) => {

  const showMenu = useSelector(state => state?.toggle?.showMenu);
  const layoutType = useSelector(state => state?.siteSettings?.data?.homePageType);

  const [searchHide, setSearchHide] = useState(true);
  const [load, setLoad] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const handleDisableSearchPages = () => {
    let location = history.location ? history.location.pathname : null;
    let searchHide = false;
    if (location && searchDisablePages.length > 0) {
      searchHide = searchDisablePages.find((o) => location === o);
      searchHide = (searchHide) ? true : false;
    }
    setSearchHide(searchHide);
  }

  useEffect(() => {
    setLoad(true);
    handleDisableSearchPages();
  }, [handleDisableSearchPages]);

  useEffect(() => {
    handleDisableSearchPages();
  }, [handleDisableSearchPages]);

  const handleMenu = () => {
    if (showMenu) {
      dispatch(toggleClose());
    } else {
      dispatch(toggleOpen());
    }
  }

  const openMenu = async () => {
    setIsOpen(true)
    document.body.classList.add('headerModalOpen');
  }

  const openClose = async () => {
    setIsOpen(false)
    document.body.classList.remove('headerModalOpen');
  }

  let borderClass, headerDesignClass, location;

  if (borderLess) {
    borderClass = s.rentAllHeaderBorderLess;
  }

  if (layoutType && (layoutType == 1 || layoutType == 3 || layoutType == 4)) {
    headerDesignClass = 'headerNewDesign';
  }

  if (history.location) {
    location = history.location.pathname;
  }

  return (
    <div className={headerDesignClass}>
      <div className={s.root}>
        <Toaster />
        <LoadingBar />
        <Navbar className={cx(s.rentAllHeader, 'rentAllHeader', borderClass, s.headerFlexContainer, { [s.fixedHeader]: location === '/s' }, { ['homeHeader']: location === '/' || location === '/home' })}
          expanded={showMenu} onToggle={handleMenu}>
          <div className={cx(s.container, s.headerFlexBox)}>
            <Navbar.Header className={cx('logoPadding', !showMenu ? 'normalPosition' : 'fixedPosition')}>
              <Navbar.Brand className={cx(s.homeLogo, 'navBrandRTL')}>
                <Logo link={"/"} className={cx(s.brand, s.brandImg)} load={load} />
              </Navbar.Brand>
            </Navbar.Header>
            <div onClick={openMenu}>
              <div className={'closebtnHidden'}>
                <DropDownMenu homeHeaderOnly={true} />
              </div>
            </div>
            <div className={cx(`${(isOpen === true) ? s.menuOpen : s.menuClose}`, s.mobileMenu)}>
              <div className={cx(s.rightMenuClose, 'closebtnHidden')}>
                <div className={s.closeButtonPosition}>
                  <div className={cx(s.closeColor, 'closeColorRTL')} onClick={openClose} >
                    ×
                  </div>
                </div>
              </div>
              <div onClick={openClose}>
                <Navigation openClose={isOpen} homeHeaderOnly={true} />
              </div>
            </div>
          </div>
        </Navbar>
      </div>
    </div>
  );
}
HomeHeader.propTypes = {
  borderLess: PropTypes.bool,
  showMenu: PropTypes.bool,
  toggleOpen: PropTypes.any.isRequired,
  formatMessage: PropTypes.any,
};
HomeHeader.defaultProps = {
  borderLess: false,
  showMenu: false,
  searchDisablePages: [
    '/',
    '/home'
  ]
}

export default (withStyles(s)(HomeHeader));